/*! powerbi-models v0.9.1 | (c) 2016 Microsoft Corporation MIT */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["powerbi-models"] = factory();
	else
		root["powerbi-models"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/* tslint:disable:no-var-requires */
	exports.advancedFilterSchema = __webpack_require__(1);
	exports.filterSchema = __webpack_require__(2);
	exports.loadSchema = __webpack_require__(3);
	exports.dashboardLoadSchema = __webpack_require__(4);
	exports.pageSchema = __webpack_require__(5);
	exports.settingsSchema = __webpack_require__(6);
	exports.basicFilterSchema = __webpack_require__(7);
	/* tslint:enable:no-var-requires */
	var jsen = __webpack_require__(8);
	function normalizeError(error) {
	    var message = error.message;
	    if (!message) {
	        message = error.path + " is invalid. Not meeting " + error.keyword + " constraint";
	    }
	    return {
	        message: message
	    };
	}
	/**
	 * Takes in schema and returns function which can be used to validate the schema with better semantics around exposing errors
	 */
	function validate(schema, options) {
	    return function (x) {
	        var validate = jsen(schema, options);
	        var isValid = validate(x);
	        if (isValid) {
	            return undefined;
	        }
	        else {
	            return validate.errors
	                .map(normalizeError);
	        }
	    };
	}
	exports.validateSettings = validate(exports.settingsSchema, {
	    schemas: {
	        basicFilter: exports.basicFilterSchema,
	        advancedFilter: exports.advancedFilterSchema
	    }
	});
	exports.validateReportLoad = validate(exports.loadSchema, {
	    schemas: {
	        settings: exports.settingsSchema,
	        basicFilter: exports.basicFilterSchema,
	        advancedFilter: exports.advancedFilterSchema
	    }
	});
	exports.validateDashboardLoad = validate(exports.dashboardLoadSchema);
	exports.validatePage = validate(exports.pageSchema);
	exports.validateFilter = validate(exports.filterSchema, {
	    schemas: {
	        basicFilter: exports.basicFilterSchema,
	        advancedFilter: exports.advancedFilterSchema
	    }
	});
	(function (FilterType) {
	    FilterType[FilterType["Advanced"] = 0] = "Advanced";
	    FilterType[FilterType["Basic"] = 1] = "Basic";
	    FilterType[FilterType["Unknown"] = 2] = "Unknown";
	})(exports.FilterType || (exports.FilterType = {}));
	var FilterType = exports.FilterType;
	function getFilterType(filter) {
	    var basicFilter = filter;
	    var advancedFilter = filter;
	    if ((typeof basicFilter.operator === "string")
	        && (Array.isArray(basicFilter.values))) {
	        return FilterType.Basic;
	    }
	    else if ((typeof advancedFilter.logicalOperator === "string")
	        && (Array.isArray(advancedFilter.conditions))) {
	        return FilterType.Advanced;
	    }
	    else {
	        return FilterType.Unknown;
	    }
	}
	exports.getFilterType = getFilterType;
	function isMeasure(arg) {
	    return arg.table !== undefined && arg.measure !== undefined;
	}
	exports.isMeasure = isMeasure;
	function isColumn(arg) {
	    return arg.table !== undefined && arg.column !== undefined;
	}
	exports.isColumn = isColumn;
	function isHierarchy(arg) {
	    return arg.table !== undefined && arg.hierarchy !== undefined && arg.hierarchyLevel !== undefined;
	}
	exports.isHierarchy = isHierarchy;
	var Filter = (function () {
	    function Filter(target) {
	        this.target = target;
	    }
	    Filter.prototype.toJSON = function () {
	        return {
	            $schema: this.schemaUrl,
	            target: this.target
	        };
	    };
	    ;
	    return Filter;
	}());
	exports.Filter = Filter;
	var BasicFilter = (function (_super) {
	    __extends(BasicFilter, _super);
	    function BasicFilter(target, operator) {
	        var values = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            values[_i - 2] = arguments[_i];
	        }
	        _super.call(this, target);
	        this.operator = operator;
	        this.schemaUrl = BasicFilter.schemaUrl;
	        if (values.length === 0) {
	            throw new Error("values must be a non-empty array. You passed: " + values);
	        }
	        /**
	         * Accept values as array instead of as individual arguments
	         * new BasicFilter('a', 'b', 1, 2);
	         * new BasicFilter('a', 'b', [1,2]);
	         */
	        if (Array.isArray(values[0])) {
	            this.values = values[0];
	        }
	        else {
	            this.values = values;
	        }
	    }
	    BasicFilter.prototype.toJSON = function () {
	        var filter = _super.prototype.toJSON.call(this);
	        filter.operator = this.operator;
	        filter.values = this.values;
	        return filter;
	    };
	    BasicFilter.schemaUrl = "http://powerbi.com/product/schema#basic";
	    return BasicFilter;
	}(Filter));
	exports.BasicFilter = BasicFilter;
	var AdvancedFilter = (function (_super) {
	    __extends(AdvancedFilter, _super);
	    function AdvancedFilter(target, logicalOperator) {
	        var conditions = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            conditions[_i - 2] = arguments[_i];
	        }
	        _super.call(this, target);
	        this.schemaUrl = AdvancedFilter.schemaUrl;
	        // Guard statements
	        if (typeof logicalOperator !== "string" || logicalOperator.length === 0) {
	            // TODO: It would be nicer to list out the possible logical operators.
	            throw new Error("logicalOperator must be a valid operator, You passed: " + logicalOperator);
	        }
	        this.logicalOperator = logicalOperator;
	        var extractedConditions;
	        /**
	         * Accept conditions as array instead of as individual arguments
	         * new AdvancedFilter('a', 'b', "And", { value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" });
	         * new AdvancedFilter('a', 'b', "And", [{ value: 1, operator: "Equals" }, { value: 2, operator: "IsGreaterThan" }]);
	         */
	        if (Array.isArray(conditions[0])) {
	            extractedConditions = conditions[0];
	        }
	        else {
	            extractedConditions = conditions;
	        }
	        if (extractedConditions.length === 0) {
	            throw new Error("conditions must be a non-empty array. You passed: " + conditions);
	        }
	        if (extractedConditions.length > 2) {
	            throw new Error("AdvancedFilters may not have more than two conditions. You passed: " + conditions.length);
	        }
	        if (extractedConditions.length === 1 && logicalOperator !== "And") {
	            throw new Error("Logical Operator must be \"And\" when there is only one condition provided");
	        }
	        this.conditions = extractedConditions;
	    }
	    AdvancedFilter.prototype.toJSON = function () {
	        var filter = _super.prototype.toJSON.call(this);
	        filter.logicalOperator = this.logicalOperator;
	        filter.conditions = this.conditions;
	        return filter;
	    };
	    AdvancedFilter.schemaUrl = "http://powerbi.com/product/schema#advanced";
	    return AdvancedFilter;
	}(Filter));
	exports.AdvancedFilter = AdvancedFilter;


/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = {
		"$schema": "http://json-schema.org/draft-04/schema#",
		"type": "object",
		"properties": {
			"target": {
				"oneOf": [
					{
						"type": "object",
						"properties": {
							"table": {
								"type": "string"
							},
							"column": {
								"type": "string"
							}
						},
						"required": [
							"table",
							"column"
						]
					},
					{
						"type": "object",
						"properties": {
							"table": {
								"type": "string"
							},
							"hierarchy": {
								"type": "string"
							},
							"hierarchyLevel": {
								"type": "string"
							}
						},
						"required": [
							"table",
							"hierarchy",
							"hierarchyLevel"
						]
					},
					{
						"type": "object",
						"properties": {
							"table": {
								"type": "string"
							},
							"measure": {
								"type": "string"
							}
						},
						"required": [
							"table",
							"measure"
						]
					}
				]
			},
			"logicalOperator": {
				"type": "string"
			},
			"conditions": {
				"type": "array",
				"items": {
					"type": "object",
					"properties": {
						"value": {
							"type": [
								"string",
								"boolean",
								"number"
							]
						},
						"operator": {
							"type": "string"
						}
					},
					"required": [
						"value",
						"operator"
					]
				}
			}
		},
		"required": [
			"target",
			"logicalOperator",
			"conditions"
		]
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = {
		"$schema": "http://json-schema.org/draft-04/schema#",
		"oneOf": [
			{
				"$ref": "#basicFilter"
			},
			{
				"$ref": "#advancedFilter"
			}
		],
		"invalidMessage": "filter is invalid"
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = {
		"$schema": "http://json-schema.org/draft-04/schema#",
		"type": "object",
		"properties": {
			"accessToken": {
				"type": "string",
				"messages": {
					"type": "accessToken must be a string",
					"required": "accessToken is required"
				}
			},
			"id": {
				"type": "string",
				"messages": {
					"type": "id must be a string",
					"required": "id is required"
				}
			},
			"settings": {
				"$ref": "#settings"
			},
			"pageName": {
				"type": "string",
				"messages": {
					"type": "pageName must be a string"
				}
			},
			"filters": {
				"type": "array",
				"items": {
					"type": "object",
					"oneOf": [
						{
							"$ref": "#basicFilter"
						},
						{
							"$ref": "#advancedFilter"
						}
					]
				},
				"invalidMessage": "filters property is invalid"
			}
		},
		"required": [
			"accessToken",
			"id"
		]
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = {
		"$schema": "http://json-schema.org/draft-04/schema#",
		"type": "object",
		"properties": {
			"accessToken": {
				"type": "string",
				"messages": {
					"type": "accessToken must be a string",
					"required": "accessToken is required"
				}
			},
			"id": {
				"type": "string",
				"messages": {
					"type": "id must be a string",
					"required": "id is required"
				}
			}
		},
		"required": [
			"accessToken",
			"id"
		]
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = {
		"$schema": "http://json-schema.org/draft-04/schema#",
		"type": "object",
		"properties": {
			"name": {
				"type": "string",
				"messages": {
					"type": "name must be a string",
					"required": "name is required"
				}
			}
		},
		"required": [
			"name"
		]
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = {
		"$schema": "http://json-schema.org/draft-04/schema#",
		"type": "object",
		"properties": {
			"filterPaneEnabled": {
				"type": "boolean",
				"messages": {
					"type": "filterPaneEnabled must be a boolean"
				}
			},
			"navContentPaneEnabled": {
				"type": "boolean",
				"messages": {
					"type": "navContentPaneEnabled must be a boolean"
				}
			}
		}
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = {
		"$schema": "http://json-schema.org/draft-04/schema#",
		"type": "object",
		"properties": {
			"target": {
				"type": "object",
				"properties": {
					"table": {
						"type": "string"
					},
					"column": {
						"type": "string"
					},
					"hierarchy": {
						"type": "string"
					},
					"hierarchyLevel": {
						"type": "string"
					},
					"measure": {
						"type": "string"
					}
				},
				"required": [
					"table"
				]
			},
			"operator": {
				"type": "string"
			},
			"values": {
				"type": "array",
				"items": {
					"type": [
						"string",
						"boolean",
						"number"
					]
				}
			}
		},
		"required": [
			"target",
			"operator",
			"values"
		]
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(9);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var PATH_REPLACE_EXPR = /\[.+?\]/g,
	    PATH_PROP_REPLACE_EXPR = /\[?(.*?)?\]/,
	    REGEX_ESCAPE_EXPR = /[\/]/g,
	    VALID_IDENTIFIER_EXPR = /^[a-z_$][0-9a-z]*$/gi,
	    INVALID_SCHEMA = 'jsen: invalid schema object',
	    browser = typeof window === 'object' && !!window.navigator,   // jshint ignore: line
	    nodev0 = typeof process === 'object' && process.version.split('.')[0] === 'v0',
	    func = __webpack_require__(11),
	    equal = __webpack_require__(12),
	    unique = __webpack_require__(13),
	    SchemaResolver = __webpack_require__(14),
	    formats = __webpack_require__(16),
	    types = {},
	    keywords = {};
	
	function inlineRegex(regex) {
	    var str = regex instanceof RegExp ? regex.toString() : new RegExp(regex).toString();
	
	    if (!nodev0) {
	        return str;
	    }
	
	    str = str.substr(1, str.length - 2);
	    str = '/' + str.replace(REGEX_ESCAPE_EXPR, '\\$&') + '/';
	
	    return str;
	}
	
	function appendToPath(path, key) {
	    VALID_IDENTIFIER_EXPR.lastIndex = 0;
	
	    return VALID_IDENTIFIER_EXPR.test(key) ?
	        path + '.' + key :
	        path + '["' + key + '"]';
	}
	
	function type(obj) {
	    var str = Object.prototype.toString.call(obj);
	    return str.substr(8, str.length - 9).toLowerCase();
	}
	
	function isInteger(obj) {
	    return (obj | 0) === obj;   // jshint ignore: line
	}
	
	types['null'] = function (path) {
	    return path + ' === null';
	};
	
	types.boolean = function (path) {
	    return 'typeof ' + path + ' === "boolean"';
	};
	
	types.string = function (path) {
	    return 'typeof ' + path + ' === "string"';
	};
	
	types.number = function (path) {
	    return 'typeof ' + path + ' === "number"';
	};
	
	types.integer = function (path) {
	    return 'typeof ' + path + ' === "number" && !(' + path + ' % 1)';
	};
	
	types.array = function (path) {
	    return path + ' !== undefined && Array.isArray(' + path + ')';
	};
	
	types.object = function (path) {
	    return path + ' !== undefined && typeof ' + path + ' === "object" && ' + path + ' !== null && !Array.isArray(' + path + ')';
	};
	
	types.date = function (path) {
	    return path + ' !== undefined && ' + path + ' instanceof Date';
	};
	
	keywords.type = function (context) {
	    if (!context.schema.type) {
	        return;
	    }
	
	    var specified = Array.isArray(context.schema.type) ? context.schema.type : [context.schema.type],
	        src = specified.map(function mapType(type) {
	            return types[type] ? types[type](context.path) || 'true' : 'true';
	        }).join(' || ');
	
	    if (src) {
	        context.code('if (!(' + src + ')) {');
	
	        context.error('type');
	
	        context.code('}');
	    }
	};
	
	keywords['enum'] = function (context) {
	    var arr = context.schema['enum'],
	        clauses = [],
	        value, enumType, i;
	
	    if (!Array.isArray(arr)) {
	        return;
	    }
	
	    for (i = 0; i < arr.length; i++) {
	        value = arr[i];
	        enumType = typeof value;
	
	        if (value === null || ['boolean', 'number', 'string'].indexOf(enumType) > -1) {
	            // simple equality check for simple data types
	            if (enumType === 'string') {
	                clauses.push(context.path + ' === "' + value + '"');
	            }
	            else {
	                clauses.push(context.path + ' === ' + value);
	            }
	        }
	        else {
	            // deep equality check for complex types or regexes
	            clauses.push('equal(' + context.path + ', ' + JSON.stringify(value) + ')');
	        }
	    }
	
	    context.code('if (!(' + clauses.join(' || ') + ')) {');
	    context.error('enum');
	    context.code('}');
	};
	
	keywords.minimum = function (context) {
	    if (typeof context.schema.minimum === 'number') {
	        context.code('if (' + context.path + ' < ' + context.schema.minimum + ') {');
	        context.error('minimum');
	        context.code('}');
	    }
	};
	
	keywords.exclusiveMinimum = function (context) {
	    if (context.schema.exclusiveMinimum === true && typeof context.schema.minimum === 'number') {
	        context.code('if (' + context.path + ' === ' + context.schema.minimum + ') {');
	        context.error('exclusiveMinimum');
	        context.code('}');
	    }
	};
	
	keywords.maximum = function (context) {
	    if (typeof context.schema.maximum === 'number') {
	        context.code('if (' + context.path + ' > ' + context.schema.maximum + ') {');
	        context.error('maximum');
	        context.code('}');
	    }
	};
	
	keywords.exclusiveMaximum = function (context) {
	    if (context.schema.exclusiveMaximum === true && typeof context.schema.maximum === 'number') {
	        context.code('if (' + context.path + ' === ' + context.schema.maximum + ') {');
	        context.error('exclusiveMaximum');
	        context.code('}');
	    }
	};
	
	keywords.multipleOf = function (context) {
	    if (typeof context.schema.multipleOf === 'number') {
	        var mul = context.schema.multipleOf,
	            decimals = mul.toString().length - mul.toFixed(0).length - 1,
	            pow = decimals > 0 ? Math.pow(10, decimals) : 1,
	            path = context.path;
	
	        if (decimals > 0) {
	            context.code('if (+(Math.round((' + path + ' * ' + pow + ') + "e+" + ' + decimals + ') + "e-" + ' + decimals + ') % ' + (mul * pow) + ' !== 0) {');
	        } else {
	            context.code('if (((' + path + ' * ' + pow + ') % ' + (mul * pow) + ') !== 0) {');
	        }
	
	        context.error('multipleOf');
	        context.code('}');
	    }
	};
	
	keywords.minLength = function (context) {
	    if (isInteger(context.schema.minLength)) {
	        context.code('if (' + context.path + '.length < ' + context.schema.minLength + ') {');
	        context.error('minLength');
	        context.code('}');
	    }
	};
	
	keywords.maxLength = function (context) {
	    if (isInteger(context.schema.maxLength)) {
	        context.code('if (' + context.path + '.length > ' + context.schema.maxLength + ') {');
	        context.error('maxLength');
	        context.code('}');
	    }
	};
	
	keywords.pattern = function (context) {
	    var regex = typeof context.schema.pattern === 'string' ?
	        new RegExp(context.schema.pattern) :
	        context.schema.pattern;
	
	    if (type(regex) === 'regexp') {
	        context.code('if (!(' + inlineRegex(regex) + ').test(' + context.path + ')) {');
	        context.error('pattern');
	        context.code('}');
	    }
	};
	
	keywords.format = function (context) {
	    if (typeof context.schema.format !== 'string' || !formats[context.schema.format]) {
	        return;
	    }
	
	    context.code('if (!(' + formats[context.schema.format] + ').test(' + context.path + ')) {');
	    context.error('format');
	    context.code('}');
	};
	
	keywords.minItems = function (context) {
	    if (isInteger(context.schema.minItems)) {
	        context.code('if (' + context.path + '.length < ' + context.schema.minItems + ') {');
	        context.error('minItems');
	        context.code('}');
	    }
	};
	
	keywords.maxItems = function (context) {
	    if (isInteger(context.schema.maxItems)) {
	        context.code('if (' + context.path + '.length > ' + context.schema.maxItems + ') {');
	        context.error('maxItems');
	        context.code('}');
	    }
	};
	
	keywords.additionalItems = function (context) {
	    if (context.schema.additionalItems === false && Array.isArray(context.schema.items)) {
	        context.code('if (' + context.path + '.length > ' + context.schema.items.length + ') {');
	        context.error('additionalItems');
	        context.code('}');
	    }
	};
	
	keywords.uniqueItems = function (context) {
	    if (context.schema.uniqueItems) {
	        context.code('if (unique(' + context.path + ').length !== ' + context.path + '.length) {');
	        context.error('uniqueItems');
	        context.code('}');
	    }
	};
	
	keywords.items = function (context) {
	    var index = context.declare(0),
	        i = 0;
	
	    if (type(context.schema.items) === 'object') {
	        context.code('for (' + index + '; ' + index + ' < ' + context.path + '.length; ' + index + '++) {');
	
	        context.validate(context.path + '[' + index + ']', context.schema.items, context.noFailFast);
	
	        context.code('}');
	    }
	    else if (Array.isArray(context.schema.items)) {
	        for (; i < context.schema.items.length; i++) {
	            context.code('if (' + context.path + '.length - 1 >= ' + i + ') {');
	
	            context.validate(context.path + '[' + i + ']', context.schema.items[i], context.noFailFast);
	
	            context.code('}');
	        }
	
	        if (type(context.schema.additionalItems) === 'object') {
	            context.code('for (' + index + ' = ' + i + '; ' + index + ' < ' + context.path + '.length; ' + index + '++) {');
	
	            context.validate(context.path + '[' + index + ']', context.schema.additionalItems, context.noFailFast);
	
	            context.code('}');
	        }
	    }
	};
	
	keywords.maxProperties = function (context) {
	    if (isInteger(context.schema.maxProperties)) {
	        context.code('if (Object.keys(' + context.path + ').length > ' + context.schema.maxProperties + ') {');
	        context.error('maxProperties');
	        context.code('}');
	    }
	};
	
	keywords.minProperties = function (context) {
	    if (isInteger(context.schema.minProperties)) {
	        context.code('if (Object.keys(' + context.path + ').length < ' + context.schema.minProperties + ') {');
	        context.error('minProperties');
	        context.code('}');
	    }
	};
	
	keywords.required = function (context) {
	    if (!Array.isArray(context.schema.required)) {
	        return;
	    }
	
	    for (var i = 0; i < context.schema.required.length; i++) {
	        context.code('if (' + appendToPath(context.path, context.schema.required[i]) + ' === undefined) {');
	        context.error('required', context.schema.required[i]);
	        context.code('}');
	    }
	};
	
	keywords.properties = function (context) {
	    if (context.validatedProperties) {
	        // prevent multiple generations of property validation
	        return;
	    }
	
	    var props = context.schema.properties,
	        propKeys = type(props) === 'object' ? Object.keys(props) : [],
	        patProps = context.schema.patternProperties,
	        patterns = type(patProps) === 'object' ? Object.keys(patProps) : [],
	        addProps = context.schema.additionalProperties,
	        addPropsCheck = addProps === false || type(addProps) === 'object',
	        prop, i, nestedPath;
	
	    // do not use this generator if we have patternProperties or additionalProperties
	    // instead, the generator below will be used for all three keywords
	    if (!propKeys.length || patterns.length || addPropsCheck) {
	        return;
	    }
	
	    for (i = 0; i < propKeys.length; i++) {
	        prop = propKeys[i];
	        nestedPath = appendToPath(context.path, prop);
	
	        context.code('if (' + nestedPath + ' !== undefined) {');
	
	        context.validate(nestedPath, props[prop], context.noFailFast);
	
	        context.code('}');
	    }
	
	    context.validatedProperties = true;
	};
	
	keywords.patternProperties = keywords.additionalProperties = function (context) {
	    if (context.validatedProperties) {
	        // prevent multiple generations of this function
	        return;
	    }
	
	    var props = context.schema.properties,
	        propKeys = type(props) === 'object' ? Object.keys(props) : [],
	        patProps = context.schema.patternProperties,
	        patterns = type(patProps) === 'object' ? Object.keys(patProps) : [],
	        addProps = context.schema.additionalProperties,
	        addPropsCheck = addProps === false || type(addProps) === 'object',
	        keys, key, n, found,
	        propKey, pattern, i;
	
	    if (!propKeys.length && !patterns.length && !addPropsCheck) {
	        return;
	    }
	
	    keys = context.declare('[]');
	    key = context.declare('""');
	    n = context.declare(0);
	
	    if (addPropsCheck) {
	        found = context.declare(false);
	    }
	
	    context.code(keys + ' = Object.keys(' + context.path + ')');
	
	    context.code('for (' + n + '; ' + n + ' < ' + keys + '.length; ' + n + '++) {')
	        (key + ' = ' + keys + '[' + n + ']')
	
	        ('if (' + context.path + '[' + key + '] === undefined) {')
	            ('continue')
	        ('}');
	
	    if (addPropsCheck) {
	        context.code(found + ' = false');
	    }
	
	    // validate regular properties
	    for (i = 0; i < propKeys.length; i++) {
	        propKey = propKeys[i];
	
	        context.code((i ? 'else ' : '') + 'if (' + key + ' === "' + propKey + '") {');
	
	        if (addPropsCheck) {
	            context.code(found + ' = true');
	        }
	
	        context.validate(appendToPath(context.path, propKey), props[propKey], context.noFailFast);
	
	        context.code('}');
	    }
	
	    // validate pattern properties
	    for (i = 0; i < patterns.length; i++) {
	        pattern = patterns[i];
	
	        context.code('if ((' + inlineRegex(pattern) + ').test(' + key + ')) {');
	
	        if (addPropsCheck) {
	            context.code(found + ' = true');
	        }
	
	        context.validate(context.path + '[' + key + ']', patProps[pattern], context.noFailFast);
	
	        context.code('}');
	    }
	
	    // validate additional properties
	    if (addPropsCheck) {
	        context.code('if (!' + found + ') {');
	
	        if (addProps === false) {
	            // do not allow additional properties
	            context.error('additionalProperties');
	        }
	        else {
	            // validate additional properties
	            context.validate(context.path + '[' + key + ']', addProps, context.noFailFast);
	        }
	
	        context.code('}');
	    }
	
	    context.code('}');
	
	    context.validatedProperties = true;
	};
	
	keywords.dependencies = function (context) {
	    if (type(context.schema.dependencies) !== 'object') {
	        return;
	    }
	
	    var key, dep, i = 0;
	
	    for (key in context.schema.dependencies) {
	        dep = context.schema.dependencies[key];
	
	        context.code('if (' + appendToPath(context.path, key) + ' !== undefined) {');
	
	        if (type(dep) === 'object') {
	            //schema dependency
	            context.validate(context.path, dep, context.noFailFast);
	        }
	        else {
	            // property dependency
	            for (i; i < dep.length; i++) {
	                context.code('if (' + appendToPath(context.path, dep[i]) + ' === undefined) {');
	                context.error('dependencies', dep[i]);
	                context.code('}');
	            }
	        }
	
	        context.code('}');
	    }
	};
	
	keywords.allOf = function (context) {
	    if (!Array.isArray(context.schema.allOf)) {
	        return;
	    }
	
	    for (var i = 0; i < context.schema.allOf.length; i++) {
	        context.validate(context.path, context.schema.allOf[i], context.noFailFast);
	    }
	};
	
	keywords.anyOf = function (context) {
	    if (!Array.isArray(context.schema.anyOf)) {
	        return;
	    }
	
	    var errCount = context.declare(0),
	        initialCount = context.declare(0),
	        found = context.declare(false),
	        i = 0;
	
	    context.code(initialCount + ' = errors.length');
	
	    for (; i < context.schema.anyOf.length; i++) {
	        context.code('if (!' + found + ') {');
	
	        context.code(errCount + ' = errors.length');
	
	        context.validate(context.path, context.schema.anyOf[i], true);
	
	        context.code(found + ' = errors.length === ' + errCount)
	        ('}');
	    }
	
	    context.code('if (!' + found + ') {');
	
	    context.error('anyOf');
	
	    context.code('} else {')
	        ('errors.length = ' + initialCount)
	    ('}');
	};
	
	keywords.oneOf = function (context) {
	    if (!Array.isArray(context.schema.oneOf)) {
	        return;
	    }
	
	    var matching = context.declare(0),
	        initialCount = context.declare(0),
	        errCount = context.declare(0),
	        i = 0;
	
	    context.code(initialCount + ' = errors.length');
	
	    for (; i < context.schema.oneOf.length; i++) {
	        context.code(errCount + ' = errors.length');
	
	        context.validate(context.path, context.schema.oneOf[i], true);
	
	        context.code('if (errors.length === ' + errCount + ') {')
	            (matching + '++')
	        ('}');
	    }
	
	    context.code('if (' + matching + ' !== 1) {');
	
	    context.error('oneOf');
	
	    context.code('} else {')
	        ('errors.length = ' + initialCount)
	    ('}');
	};
	
	keywords.not = function (context) {
	    if (type(context.schema.not) !== 'object') {
	        return;
	    }
	
	    var errCount = context.declare(0);
	
	    context.code(errCount + ' = errors.length');
	
	    context.validate(context.path, context.schema.not, true);
	
	    context.code('if (errors.length === ' + errCount + ') {');
	
	    context.error('not');
	
	    context.code('} else {')
	        ('errors.length = ' + errCount)
	    ('}');
	};
	
	['minimum', 'exclusiveMinimum', 'maximum', 'exclusiveMaximum', 'multipleOf']
	    .forEach(function (keyword) { keywords[keyword].type = 'number'; });
	
	['minLength', 'maxLength', 'pattern', 'format']
	    .forEach(function (keyword) { keywords[keyword].type = 'string'; });
	
	['minItems', 'maxItems', 'additionalItems', 'uniqueItems', 'items']
	    .forEach(function (keyword) { keywords[keyword].type = 'array'; });
	
	['maxProperties', 'minProperties', 'required', 'properties', 'patternProperties', 'additionalProperties', 'dependencies']
	    .forEach(function (keyword) { keywords[keyword].type = 'object'; });
	
	function getGenerators(schema) {
	    var keys = Object.keys(schema),
	        start = [],
	        perType = {},
	        gen, i;
	
	    for (i = 0; i < keys.length; i++) {
	        gen = keywords[keys[i]];
	
	        if (!gen) {
	            continue;
	        }
	
	        if (gen.type) {
	            if (!perType[gen.type]) {
	                perType[gen.type] = [];
	            }
	
	            perType[gen.type].push(gen);
	        }
	        else {
	            start.push(gen);
	        }
	    }
	
	    return start.concat(Object.keys(perType).reduce(function (arr, key) {
	        return arr.concat(perType[key]);
	    }, []));
	}
	
	function replaceIndexedProperty(match) {
	    var index = match.replace(PATH_PROP_REPLACE_EXPR, '$1');
	
	    if (!isNaN(+index)) {
	        // numeric index in array
	        return '.' + index;
	    }
	    else if (index[0] === '"') {
	        // string key for an object property
	        return '[\\"' + index.substr(1, index.length - 2) + '\\"]';
	    }
	
	    // variable containing the actual key
	    return '." + ' + index + ' + "';
	}
	
	function getPathExpression(path) {
	    return '"' + path.replace(PATH_REPLACE_EXPR, replaceIndexedProperty).substr(5) + '"';
	}
	
	function clone(obj) {
	    var cloned = obj,
	        objType = type(obj),
	        key, i;
	
	    if (objType === 'object') {
	        cloned = {};
	
	        for (key in obj) {
	            cloned[key] = clone(obj[key]);
	        }
	    }
	    else if (objType === 'array') {
	        cloned = [];
	
	        for (i = 0; i < obj.length; i++) {
	            cloned[i] = clone(obj[i]);
	        }
	    }
	    else if (objType === 'regexp') {
	        return new RegExp(obj);
	    }
	    else if (objType === 'date') {
	        return new Date(obj.toJSON());
	    }
	
	    return cloned;
	}
	
	function PropertyMarker() {
	    this.objects = [];
	    this.properties = [];
	}
	
	PropertyMarker.prototype.mark = function (obj, key) {
	    var index = this.objects.indexOf(obj),
	        prop;
	
	    if (index < 0) {
	        this.objects.push(obj);
	
	        prop = {};
	        prop[key] = 1;
	
	        this.properties.push(prop);
	
	        return;
	    }
	
	    prop = this.properties[index];
	
	    prop[key] = prop[key] ? prop[key] + 1 : 1;
	};
	
	PropertyMarker.prototype.deleteDuplicates = function () {
	    var key, i;
	
	    for (i = 0; i < this.properties.length; i++) {
	        for (key in this.properties[i]) {
	            if (this.properties[i][key] > 1) {
	                delete this.objects[i][key];
	            }
	        }
	    }
	};
	
	PropertyMarker.prototype.dispose = function () {
	    this.objects.length = 0;
	    this.properties.length = 0;
	};
	
	function build(schema, def, additional, resolver, parentMarker) {
	    var defType, defValue, key, i, propertyMarker;
	
	    if (type(schema) !== 'object') {
	        return def;
	    }
	
	    schema = resolver.resolve(schema);
	
	    if (def === undefined && schema.hasOwnProperty('default')) {
	        def = clone(schema['default']);
	    }
	
	    defType = type(def);
	
	    if (defType === 'object' && type(schema.properties) === 'object') {
	        for (key in schema.properties) {
	            defValue = build(schema.properties[key], def[key], additional, resolver);
	
	            if (defValue !== undefined) {
	                def[key] = defValue;
	            }
	        }
	
	        for (key in def) {
	            if (!(key in schema.properties) &&
	                (schema.additionalProperties === false ||
	                (additional === false && !schema.additionalProperties))) {
	
	                if (parentMarker) {
	                    parentMarker.mark(def, key);
	                }
	                else {
	                    delete def[key];
	                }
	            }
	        }
	    }
	    else if (defType === 'array' && schema.items) {
	        if (type(schema.items) === 'array') {
	            for (i = 0; i < schema.items.length; i++) {
	                defValue = build(schema.items[i], def[i], additional, resolver);
	
	                if (defValue !== undefined || i < def.length) {
	                    def[i] = defValue;
	                }
	            }
	        }
	        else if (def.length) {
	            for (i = 0; i < def.length; i++) {
	                def[i] = build(schema.items, def[i], additional, resolver);
	            }
	        }
	    }
	    else if (type(schema.allOf) === 'array' && schema.allOf.length) {
	        propertyMarker = new PropertyMarker();
	
	        for (i = 0; i < schema.allOf.length; i++) {
	            def = build(schema.allOf[i], def, additional, resolver, propertyMarker);
	        }
	
	        propertyMarker.deleteDuplicates();
	        propertyMarker.dispose();
	    }
	
	    return def;
	}
	
	function jsen(schema, options) {
	    if (type(schema) !== 'object') {
	        throw new Error(INVALID_SCHEMA);
	    }
	
	    options = options || {};
	
	    var missing$Ref = options.missing$Ref || false,
	        resolver = new SchemaResolver(schema, options.schemas, missing$Ref),
	        counter = 0,
	        id = function () { return 'i' + (counter++); },
	        funcache = {},
	        compiled,
	        refs = {
	            errors: []
	        },
	        scope = {
	            equal: equal,
	            unique: unique,
	            refs: refs
	        };
	
	    function cache(schema) {
	        var deref = resolver.resolve(schema),
	            ref = schema.$ref,
	            cached = funcache[ref],
	            func;
	
	        if (!cached) {
	            cached = funcache[ref] = {
	                key: id(),
	                func: function (data) {
	                    return func(data);
	                }
	            };
	
	            func = compile(deref);
	
	            Object.defineProperty(cached.func, 'errors', {
	                get: function () {
	                    return func.errors;
	                }
	            });
	
	            refs[cached.key] = cached.func;
	        }
	
	        return 'refs.' + cached.key;
	    }
	
	    function compile(schema) {
	        function declare(def) {
	            var variname = id();
	
	            code.def(variname, def);
	
	            return variname;
	        }
	
	        function validate(path, schema, noFailFast) {
	            var context,
	                cachedRef,
	                pathExp,
	                index,
	                lastType,
	                format,
	                gens,
	                gen,
	                i;
	
	            function error(keyword, key) {
	                var varid,
	                    errorPath = path,
	                    message = (key && schema.properties && schema.properties[key] && schema.properties[key].requiredMessage) ||
	                        schema.invalidMessage;
	
	                if (!message) {
	                    message = key && schema.properties && schema.properties[key] && schema.properties[key].messages &&
	                        schema.properties[key].messages[keyword] ||
	                        schema.messages && schema.messages[keyword];
	                }
	
	                if (path.indexOf('[') > -1) {
	                    // create error objects dynamically when path contains indexed property expressions
	                    errorPath = getPathExpression(path);
	
	                    if (key) {
	                        errorPath = errorPath ? errorPath + ' + ".' + key + '"' : key;
	                    }
	
	                    code('errors.push({')
	                        ('path: ' +  errorPath + ', ')
	                        ('keyword: "' + keyword + '"' + (message ? ',' : ''));
	
	                    if (message) {
	                        code('message: "' + message + '"');
	                    }
	
	                    code('})');
	                }
	                else {
	                    // generate faster code when no indexed properties in the path
	                    varid = id();
	
	                    errorPath = errorPath.substr(5);
	
	                    if (key) {
	                        errorPath = errorPath ? errorPath + '.' + key : key;
	                    }
	
	                    refs[varid] = {
	                        path: errorPath,
	                        keyword: keyword
	                    };
	
	                    if (message) {
	                        refs[varid].message = message;
	                    }
	
	                    code('errors.push(refs.' + varid + ')');
	                }
	
	                if (!noFailFast && !options.greedy) {
	                    code('return (validate.errors = errors) && false');
	                }
	            }
	
	            if (schema.$ref !== undefined) {
	                cachedRef = cache(schema);
	                pathExp = getPathExpression(path);
	                index = declare(0);
	
	                code('if (!' + cachedRef + '(' + path + ')) {')
	                    ('if (' + cachedRef + '.errors) {')
	                        ('errors.push.apply(errors, ' + cachedRef + '.errors)')
	                        ('for (' + index + ' = 0; ' + index + ' < ' + cachedRef + '.errors.length; ' + index + '++) {')
	                            ('if (' + cachedRef + '.errors[' + index + '].path) {')
	                                ('errors[errors.length - ' + cachedRef + '.errors.length + ' + index + '].path = ' + pathExp +
	                                    ' + "." + ' + cachedRef + '.errors[' + index + '].path')
	                            ('} else {')
	                                ('errors[errors.length - ' + cachedRef + '.errors.length + ' + index + '].path = ' + pathExp)
	                            ('}')
	                        ('}')
	                    ('}')
	                ('}');
	
	                return;
	            }
	
	            context = {
	                path: path,
	                schema: schema,
	                code: code,
	                declare: declare,
	                validate: validate,
	                error: error,
	                noFailFast: noFailFast
	            };
	
	            gens = getGenerators(schema);
	
	            for (i = 0; i < gens.length; i++) {
	                gen = gens[i];
	
	                if (gen.type && lastType !== gen.type) {
	                    if (lastType) {
	                        code('}');
	                    }
	
	                    lastType = gen.type;
	
	                    code('if (' + types[gen.type](path) + ') {');
	                }
	
	                gen(context);
	            }
	
	            if (lastType) {
	                code('}');
	            }
	
	            if (schema.format && options.formats) {
	                format = options.formats[schema.format];
	
	                if (format) {
	                    if (typeof format === 'string' || format instanceof RegExp) {
	                        code('if (!(' + inlineRegex(format) + ').test(' + context.path + ')) {');
	                        error('format');
	                        code('}');
	                    }
	                    else if (typeof format === 'function') {
	                        (scope.formats || (scope.formats = {}))[schema.format] = format;
	                        (scope.schemas || (scope.schemas = {}))[schema.format] = schema;
	
	                        code('if (!formats["' + schema.format + '"](' + context.path + ', schemas["' + schema.format + '"])) {');
	                        error('format');
	                        code('}');
	                    }
	                }
	            }
	        }
	
	        var code = func('validate', 'data')
	            ('var errors = []');
	
	        validate('data', schema);
	
	        code('return (validate.errors = errors) && errors.length === 0');
	
	        compiled = code.compile(scope);
	
	        compiled.errors = [];
	
	        compiled.build = function (initial, options) {
	            return build(
	                schema,
	                (options && options.copy === false ? initial : clone(initial)),
	                options && options.additionalProperties,
	                resolver);
	        };
	
	        return compiled;
	    }
	
	    return compile(schema);
	}
	
	jsen.browser = browser;
	jsen.clone = clone;
	jsen.equal = equal;
	jsen.unique = unique;
	jsen.resolve = SchemaResolver.resolvePointer;
	
	module.exports = jsen;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ },
/* 10 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function func() {
	    var name = arguments[0] || '',
	        args = [].join.call([].slice.call(arguments, 1), ', '),
	        lines = '',
	        vars = '',
	        ind = 1,
	        tab = '  ',
	        bs = '{[',  // block start
	        be = '}]',  // block end
	        space = function () {
	            return new Array(ind + 1).join(tab);
	        },
	        push = function (line) {
	            lines += space() + line + '\n';
	        },
	        builder = function (line) {
	            var first = line[0],
	                last = line[line.length - 1];
	
	            if (be.indexOf(first) > -1 && bs.indexOf(last) > -1) {
	                ind--;
	                push(line);
	                ind++;
	            }
	            else if (bs.indexOf(last) > -1) {
	                push(line);
	                ind++;
	            }
	            else if (be.indexOf(first) > -1) {
	                ind--;
	                push(line);
	            }
	            else {
	                push(line);
	            }
	
	            return builder;
	        };
	
	    builder.def = function (id, def) {
	        vars += space() + 'var ' + id + (def !== undefined ? ' = ' + def : '') + '\n';
	
	        return builder;
	    };
	
	    builder.toSource = function () {
	        return 'function ' + name + '(' + args + ') {\n' + vars + '\n' + lines + '\n}';
	    };
	
	    builder.compile = function (scope) {
	        var src = 'return (' + builder.toSource() + ')',
	            scp = scope || {},
	            keys = Object.keys(scp),
	            vals = keys.map(function (key) { return scp[key]; });
	
	        return Function.apply(null, keys.concat(src)).apply(null, vals);
	    };
	
	    return builder;
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	function type(obj) {
	    var str = Object.prototype.toString.call(obj);
	    return str.substr(8, str.length - 9).toLowerCase();
	}
	
	function deepEqual(a, b) {
	    var keysA = Object.keys(a).sort(),
	        keysB = Object.keys(b).sort(),
	        i, key;
	
	    if (!equal(keysA, keysB)) {
	        return false;
	    }
	
	    for (i = 0; i < keysA.length; i++) {
	        key = keysA[i];
	
	        if (!equal(a[key], b[key])) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function equal(a, b) {  // jshint ignore: line
	    var typeA = typeof a,
	        typeB = typeof b,
	        i;
	
	    // get detailed object type
	    if (typeA === 'object') {
	        typeA = type(a);
	    }
	
	    // get detailed object type
	    if (typeB === 'object') {
	        typeB = type(b);
	    }
	
	    if (typeA !== typeB) {
	        return false;
	    }
	
	    if (typeA === 'object') {
	        return deepEqual(a, b);
	    }
	
	    if (typeA === 'regexp') {
	        return a.toString() === b.toString();
	    }
	
	    if (typeA === 'array') {
	        if (a.length !== b.length) {
	            return false;
	        }
	
	        for (i = 0; i < a.length; i++) {
	            if (!equal(a[i], b[i])) {
	                return false;
	            }
	        }
	
	        return true;
	    }
	
	    return a === b;
	}
	
	module.exports = equal;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var equal = __webpack_require__(12);
	
	function findIndex(arr, value, comparator) {
	    for (var i = 0, len = arr.length; i < len; i++) {
	        if (comparator(arr[i], value)) {
	            return i;
	        }
	    }
	
	    return -1;
	}
	
	module.exports = function unique(arr) {
	    return arr.filter(function uniqueOnly(value, index, self) {
	        return findIndex(self, value, equal) === index;
	    });
	};
	
	module.exports.findIndex = findIndex;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var metaschema = __webpack_require__(15),
	    INVALID_SCHEMA_REFERENCE = 'jsen: invalid schema reference';
	
	function get(obj, path) {
	    if (!path.length) {
	        return obj;
	    }
	
	    var key = path.shift(),
	        val;
	
	    if (obj && typeof obj === 'object' && obj.hasOwnProperty(key)) {
	        val = obj[key];
	    }
	
	    if (path.length) {
	        if (val && typeof val === 'object') {
	            return get(val, path);
	        }
	
	        return undefined;
	    }
	
	    return val;
	}
	
	function refToPath(ref) {
	    var index = ref.indexOf('#'),
	        path;
	
	    if (index !== 0) {
	        return [ref];
	    }
	
	    ref = ref.substr(index + 1);
	
	    if (!ref) {
	        return [];
	    }
	
	    path = ref.split('/').map(function (segment) {
	        // Reference: http://tools.ietf.org/html/draft-ietf-appsawg-json-pointer-08#section-3
	        return decodeURIComponent(segment)
	            .replace(/~1/g, '/')
	            .replace(/~0/g, '~');
	    });
	
	    if (ref[0] === '/') {
	        path.shift();
	    }
	
	    return path;
	}
	
	function refFromId(obj, ref) {
	    if (obj && typeof obj === 'object') {
	        if (obj.id === ref) {
	            return obj;
	        }
	
	        return Object.keys(obj).reduce(function (resolved, key) {
	            return resolved || refFromId(obj[key], ref);
	        }, undefined);
	    }
	
	    return undefined;
	}
	
	function getResolvers(schemas) {
	    var keys = Object.keys(schemas),
	        resolvers = {},
	        key, i;
	
	    for (i = 0; i < keys.length; i++) {
	        key = keys[i];
	        resolvers[key] = new SchemaResolver(schemas[key]);
	    }
	
	    return resolvers;
	}
	
	function SchemaResolver(rootSchema, external, missing$Ref) {  // jshint ignore: line
	    this.rootSchema = rootSchema;
	    this.resolvedRootSchema = null;
	    this.cache = {};
	    this.missing$Ref = missing$Ref;
	
	    this.resolvers = external && typeof external === 'object' ?
	        getResolvers(external) :
	        null;
	}
	
	SchemaResolver.prototype.resolveRef = function (ref) {
	    var err = new Error(INVALID_SCHEMA_REFERENCE + ' ' + ref),
	        root = this.rootSchema,
	        resolvedRoot = this.resolvedRootSchema,
	        externalResolver,
	        path,
	        dest;
	
	    if (!ref || typeof ref !== 'string') {
	        throw err;
	    }
	
	    if (ref === metaschema.id) {
	        dest = metaschema;
	    }
	
	    if (dest === undefined && resolvedRoot) {
	        dest = refFromId(resolvedRoot, ref);
	    }
	
	    if (dest === undefined) {
	        dest = refFromId(root, ref);
	    }
	
	    if (dest === undefined) {
	        path = refToPath(ref);
	
	        if (resolvedRoot) {
	            dest = get(resolvedRoot, path.slice(0));
	        }
	
	        if (dest === undefined) {
	            dest = get(root, path.slice(0));
	        }
	    }
	
	    if (dest === undefined && path.length && this.resolvers) {
	        externalResolver = get(this.resolvers, path);
	
	        if (externalResolver) {
	            dest = externalResolver.resolve(externalResolver.rootSchema);
	        }
	    }
	
	    if (dest === undefined || typeof dest !== 'object') {
	        if (this.missing$Ref) {
	            dest = {};
	        } else {
	            throw err;
	        }
	    }
	
	    if (this.cache[ref] === dest) {
	        return dest;
	    }
	
	    this.cache[ref] = dest;
	
	    if (dest.$ref !== undefined) {
	        dest = this.cache[ref] = this.resolveRef(dest.$ref);
	    }
	
	    return dest;
	};
	
	SchemaResolver.prototype.resolve = function (schema) {
	    if (!schema || typeof schema !== 'object') {
	        return schema;
	    }
	
	    var ref = schema.$ref,
	        resolved = this.cache[ref];
	
	    if (ref === undefined) {
	        return schema;
	    }
	
	    if (resolved !== undefined) {
	        return resolved;
	    }
	
	    resolved = this.resolveRef(ref);
	
	    if (schema === this.rootSchema && schema !== resolved) {
	        // cache the resolved root schema
	        this.resolvedRootSchema = resolved;
	    }
	
	    return resolved;
	};
	
	SchemaResolver.resolvePointer = function (obj, pointer) {
	    return get(obj, refToPath(pointer));
	};
	
	module.exports = SchemaResolver;

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = {
		"id": "http://json-schema.org/draft-04/schema#",
		"$schema": "http://json-schema.org/draft-04/schema#",
		"description": "Core schema meta-schema",
		"definitions": {
			"schemaArray": {
				"type": "array",
				"minItems": 1,
				"items": {
					"$ref": "#"
				}
			},
			"positiveInteger": {
				"type": "integer",
				"minimum": 0
			},
			"positiveIntegerDefault0": {
				"allOf": [
					{
						"$ref": "#/definitions/positiveInteger"
					},
					{
						"default": 0
					}
				]
			},
			"simpleTypes": {
				"anyOf": [
					{
						"enum": [
							"array",
							"boolean",
							"integer",
							"null",
							"number",
							"object",
							"string",
							"any"
						]
					},
					{
						"type": "string"
					}
				]
			},
			"stringArray": {
				"type": "array",
				"items": {
					"type": "string"
				},
				"minItems": 1,
				"uniqueItems": true
			}
		},
		"type": "object",
		"properties": {
			"id": {
				"type": "string",
				"format": "uri"
			},
			"$schema": {
				"type": "string",
				"format": "uri"
			},
			"title": {
				"type": "string"
			},
			"description": {
				"type": "string"
			},
			"default": {},
			"multipleOf": {
				"type": "number",
				"minimum": 0,
				"exclusiveMinimum": true
			},
			"maximum": {
				"type": "number"
			},
			"exclusiveMaximum": {
				"type": "boolean",
				"default": false
			},
			"minimum": {
				"type": "number"
			},
			"exclusiveMinimum": {
				"type": "boolean",
				"default": false
			},
			"maxLength": {
				"$ref": "#/definitions/positiveInteger"
			},
			"minLength": {
				"$ref": "#/definitions/positiveIntegerDefault0"
			},
			"pattern": {
				"type": "string",
				"format": "regex"
			},
			"additionalItems": {
				"anyOf": [
					{
						"type": "boolean"
					},
					{
						"$ref": "#"
					}
				],
				"default": {}
			},
			"items": {
				"anyOf": [
					{
						"$ref": "#"
					},
					{
						"$ref": "#/definitions/schemaArray"
					}
				],
				"default": {}
			},
			"maxItems": {
				"$ref": "#/definitions/positiveInteger"
			},
			"minItems": {
				"$ref": "#/definitions/positiveIntegerDefault0"
			},
			"uniqueItems": {
				"type": "boolean",
				"default": false
			},
			"maxProperties": {
				"$ref": "#/definitions/positiveInteger"
			},
			"minProperties": {
				"$ref": "#/definitions/positiveIntegerDefault0"
			},
			"required": {
				"$ref": "#/definitions/stringArray"
			},
			"additionalProperties": {
				"anyOf": [
					{
						"type": "boolean"
					},
					{
						"$ref": "#"
					}
				],
				"default": {}
			},
			"definitions": {
				"type": "object",
				"additionalProperties": {
					"$ref": "#"
				},
				"default": {}
			},
			"properties": {
				"type": "object",
				"additionalProperties": {
					"$ref": "#"
				},
				"default": {}
			},
			"patternProperties": {
				"type": "object",
				"additionalProperties": {
					"$ref": "#"
				},
				"default": {}
			},
			"dependencies": {
				"type": "object",
				"additionalProperties": {
					"anyOf": [
						{
							"$ref": "#"
						},
						{
							"$ref": "#/definitions/stringArray"
						}
					]
				}
			},
			"enum": {
				"type": "array",
				"minItems": 1,
				"uniqueItems": true
			},
			"type": {
				"anyOf": [
					{
						"$ref": "#/definitions/simpleTypes"
					},
					{
						"type": "array",
						"items": {
							"$ref": "#/definitions/simpleTypes"
						},
						"minItems": 1,
						"uniqueItems": true
					}
				]
			},
			"allOf": {
				"$ref": "#/definitions/schemaArray"
			},
			"anyOf": {
				"$ref": "#/definitions/schemaArray"
			},
			"oneOf": {
				"$ref": "#/definitions/schemaArray"
			},
			"not": {
				"$ref": "#"
			}
		},
		"dependencies": {
			"exclusiveMaximum": [
				"maximum"
			],
			"exclusiveMinimum": [
				"minimum"
			]
		},
		"default": {}
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	var formats = {};
	
	// reference: http://dansnetwork.com/javascript-iso8601rfc3339-date-parser/
	formats['date-time'] = /(\d\d\d\d)(-)?(\d\d)(-)?(\d\d)(T)?(\d\d)(:)?(\d\d)(:)?(\d\d)(\.\d+)?(Z|([+-])(\d\d)(:)?(\d\d))/;
	// reference: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js#L7
	formats.uri = /^([a-zA-Z][a-zA-Z0-9+-.]*:){0,1}\/\/[^\s]*$/;
	// reference: http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
	//            http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
	formats.email = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
	// reference: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
	formats.ipv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
	// reference: http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
	formats.ipv6 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|[fF][eE]80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::([fF]{4}(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
	// reference: http://stackoverflow.com/questions/106179/regular-expression-to-match-dns-hostname-or-ip-address#answer-3824105
	formats.hostname = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]))*$/;
	
	module.exports = formats;

/***/ }
/******/ ])
});
;
//# sourceMappingURL=models.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/powerbi-models/dist/models.js
 ** module id = 5
 ** module chunks = 0
 **/